import { IRecentSearch, IRecentSearchApiResponse } from './types';

interface RecentSearchesProps {
    visitorId?: string;
    userId?: string;
}

const getRecentSearches = async ({ visitorId, userId }: RecentSearchesProps): Promise<IRecentSearch[]> => {
    if (!visitorId) return [];

    try {
        const url = `/home/api/recentsearches?visitorId=${visitorId}&userId=${userId}`;
        const response = await fetch(url);
        const data: IRecentSearchApiResponse = await response.json();
        if (data && data.items && data.items.length > 0) {
            return data.items;
        }
        return [];
    } catch (err) {
        console.error(err);
        return [];
    }
};

export default getRecentSearches;
